import React from 'react';

const OutlineExportIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.5003 18.9587H7.50033C2.97533 18.9587 1.04199 17.0253 1.04199 12.5003V7.50033C1.04199 2.97533 2.97533 1.04199 7.50033 1.04199H12.5003C17.0253 1.04199 18.9587 2.97533 18.9587 7.50033V12.5003C18.9587 17.0253 17.0253 18.9587 12.5003 18.9587ZM7.50033 2.29199C3.65866 2.29199 2.29199 3.65866 2.29199 7.50033V12.5003C2.29199 16.342 3.65866 17.7087 7.50033 17.7087H12.5003C16.342 17.7087 17.7087 16.342 17.7087 12.5003V7.50033C17.7087 3.65866 16.342 2.29199 12.5003 2.29199H7.50033Z"
      fill="currentColor"
    />
    <path
      d="M12.4999 8.54967C12.3415 8.54967 12.1832 8.49134 12.0582 8.36634L9.99987 6.30802L7.94153 8.36634C7.69987 8.60801 7.29987 8.60801 7.0582 8.36634C6.81654 8.12467 6.81654 7.72467 7.0582 7.48301L9.5582 4.98301C9.79987 4.74134 10.1999 4.74134 10.4415 4.98301L12.9415 7.48301C13.1832 7.72467 13.1832 8.12467 12.9415 8.36634C12.8165 8.49134 12.6582 8.54967 12.4999 8.54967Z"
      fill="currentColor"
    />
    <path
      d="M10 12.7165C9.65833 12.7165 9.375 12.4331 9.375 12.0915V5.4248C9.375 5.08314 9.65833 4.7998 10 4.7998C10.3417 4.7998 10.625 5.08314 10.625 5.4248V12.0915C10.625 12.4415 10.3417 12.7165 10 12.7165Z"
      fill="currentColor"
    />
    <path
      d="M9.99972 15.1921C8.24138 15.1921 6.47471 14.9088 4.79971 14.3505C4.47471 14.2421 4.29971 13.8838 4.40804 13.5588C4.51638 13.2338 4.87472 13.0505 5.19972 13.1671C8.29972 14.2005 11.7081 14.2005 14.8081 13.1671C15.1331 13.0588 15.4914 13.2338 15.5997 13.5588C15.708 13.8838 15.533 14.2421 15.208 14.3505C13.5247 14.9171 11.758 15.1921 9.99972 15.1921Z"
      fill="currentColor"
    />
  </svg>
);

export default OutlineExportIcon;
